import { render, staticRenderFns } from "./userRoleConfig.vue?vue&type=template&id=0b634dc5&"
import script from "./userRoleConfig.vue?vue&type=script&lang=ts&"
export * from "./userRoleConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports